module.exports = __webpack_public_path__ + "img/Kitty.38c322a4.jpg";